/**
 * Feature Flags Configuration for Lobby2.0
 * Allows gradual migration and safe rollout of new features
 */

export const features = {
  // State management
  useZustandStores: true, // Always true for lobby2.0
  useReactQuery: true,    // Always true for lobby2.0
  
  // Communication
  useModernEventBus: true,
  useValtioExternal: true,
  
  // Styling
  useStyledComponents: true,
  useDesignSystem: true,
  
  // Performance
  enableLazyLoading: process.env['NODE_ENV'] === 'production',
  enableCodeSplitting: true,
  
  // Features
  showTournaments: true,
  showFavorites: true,
  showJackpots: true,
  showSearch: true,
  showSettings: true,
  
  // Development
  enableDevTools: process.env['NODE_ENV'] === 'development',
  enableHotReload: process.env['NODE_ENV'] === 'development',
  enableDebugLogs: process.env['NODE_ENV'] === 'development',
  
  // Experimental
  enableAnimations: true,
  enableSoundEffects: true,
  enableKeyboardNavigation: false, // Future feature
  enableAccessibility: false,      // Future feature
  
  // Legacy compatibility (for migration period)
  enableLegacyBridge: false, // Not needed in lobby2.0
  supportOldBrowsers: false, // Modern browsers only
} as const;

export type FeatureKey = keyof typeof features;